import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonHTMLAttributes } from "react";

export default function PrimaryButton({
    className = "",
    disabled,
    children,
    success,
    loading,
    invert = false,
    type = "button",
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
    invert?: boolean;
    success?: boolean;
    loading?: boolean;
}) {
    return (
        <button
            type={type}
            {...props}
            className={
                `inline-flex text-center justify-center shadow-sm md:gap-2 items-center rounded-md border  px-4 py-2 text-xs uppercase tracking-widest transition duration-500 ease-in-out font-semibold focus:outline-none focus:ring-2  focus:ring-offset-2 ${
                    invert
                        ? "bg-white text-blue4 enabled:hover:bg-blue4 enabled:hover:text-white active:bg-blue4 border-blue4"
                        : "bg-blue4 text-white enabled:hover:bg-blue6 enabled:hover:text-white focus:bg-blue6  active:bg-blue3 focus:ring-blue6 border-transparent"
                }
                ${disabled && "opacity-25"} ` + className
            }
            disabled={disabled}
        >
            {loading && <span className="btn-spinner text-white"></span>}
            {success && <FontAwesomeIcon icon={faCheck} />}
            {children}
        </button>
    );
}
